import { createSelector } from '@ngrx/store';
import { SelectSupplierModuleState } from '../suppliermodule.selector';

export const getGeneralState = createSelector(SelectSupplierModuleState, state => state.GeneralSettingsState);
export const getGeneralSettings = createSelector(getGeneralState, state => state.settings);
export const getAvailableConfiguration = createSelector(getGeneralState, state => state.availableConfiguration);